import axios from '@/utils/axiosInt.js'
export default { //办卡量
    getData(option) { //高速加油站停靠 高速运营时段
        return axios.post('/bi-api/truckOil/totalCountry?time=' + new Date() * 1, option)
    },
    getAbnormalData(option) { //高速加油站停靠 高速运营时段
        return axios.post('/bi-api/abnormal/totalCountry?time=' + new Date() * 1, option)
    },
};